import script from "./FooterTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&setup=true&lang=js"

import "./FooterTemplate.vue?vue&type=style&index=0&id=98218754&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98218754"]])

export default __exports__